// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/TailorDateField/Size.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {TailorDateField, view} from '@sail/ui';

export const Size = () => (
  <view.div
    css={{
      stack: 'y',
      gap: 'large',
    }}
  >
    <TailorDateField
      label="Date of birth (small)"
      description="Enter your birthday"
      size="small"
    />
    <TailorDateField
      label="Date of birth (medium)"
      description="Enter your birthday"
      size="medium"
    />
    <TailorDateField
      label="Date of birth (large)"
      description="Enter your birthday"
      size="large"
    />
  </view.div>
);
